import React, {useState} from "react";
import {
  TextField,
  Button,
  FormLabel,
  CircularProgress,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { setSuccess } from "../../../Redux/AlertReducer";
import { useDispatch } from "react-redux";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";

export const FormEditRole = ({ data, permissions, setData }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  const handlePermissionChange = (e) => {
    const { checked, value } = e.target;
    setData((prev) => ({
      ...prev,
      permissions: checked
          ? [...(prev.permissions || []), value]
          : (prev.permissions || []).filter((id) => id !== value),
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoadingSubmit(true);

    try {
      // Use PUT method for updating
      const { result, response, message } = await Helper.Post({
        url: api_Routes.Roles.Edit + id,
        data: data,
      });

      setIsLoadingSubmit(false);
      if (response) {
        dispatch(setSuccess(true));
        navigate("/roles"); // Redirect to roles list
      }
    } catch (error) {
      console.error("An error occurred during form submission:", error);
      setIsLoadingSubmit(false);
    }
  };

  return (
      <form onSubmit={handleSubmit}>
        <TextField
            fullWidth
            margin="normal"
            label="Name"
            name="name"
            required
            autoComplete="off"
            value={data.name}
            onChange={handleInputChange}
            variant="outlined"
        />

        {/* Permissions Checkboxes with Grid Layout */}
        <div className="mt-4">
          <FormLabel
              sx={{ fontWeight: "bold", textAlign: "left", width: "100%" }}
              component="legend"
          >
            Permissions:
          </FormLabel>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {permissions?.map((permission) => (
                <FormControlLabel
                    key={permission.id}
                    control={
                      <Checkbox
                          name="permissions[]"
                          value={permission.id.toString()}
                          checked={data.permissions.includes(permission.id.toString())}
                          onChange={handlePermissionChange}
                      />
                    }
                    label={permission.name}
                />
            ))}
          </div>
        </div>

        <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={isLoadingSubmit}
            color="primary"
            sx={{
              display: isLoadingSubmit ? "flex" : "block",
              marginTop: 2,
              width: "20%",
              marginX: "auto",
              fontWeight: "bold",
              justifyContent: "center",
            }}
        >
          {isLoadingSubmit ? (
              <CircularProgress size={24} color="primary" />
          ) : (
              "Update Role"
          )}
        </Button>
      </form>
  );
};